import styled, { css } from 'styled-components';
import {
  NeuButton,
  NeuCard,
  NeuFeedback,
  NeuIcon,
  NeuTextarea
} from '@neutron/react';

interface IDropdownProps {
  showPopover: boolean;
}

interface IModalFooterProps {
  right?: boolean;
}

interface ICSSProps {
  autoWidth?: boolean | undefined;
  centered?: boolean | undefined;
  cursorType?: boolean;
  color?: string;
}

export const AddIssueCard = styled(NeuCard)`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 29em;
  background: #f6f6f6 !important;
  padding-inline-start: 0;
  padding-inline-end: 0;
  padding-top: 0;
  padding-bottom: 0;
  margin-inline-end: 0;
  margin-top: 0;
  z-index: 10;
`;

export const CardHeader = styled(NeuCard)`
  gap: 0;
  padding: 0 !important;
  width: 100%;
  background: white !important;
`;

export const CardMainHeader = styled.div`
  display: flex !important;
  flex-direction: row !important;
  justify-content: space-between !important;
  align-items: center !important;
  padding-top: var(--card-spacing);
  padding-right: var(--card-spacing);
  padding-bottom: calc(var(--card-spacing) / 2);
  padding-left: var(--card-spacing);
  height: 56px;
  width: 100%;
`;

export const CardTitle = styled.div``;

export const ModalCardContent = styled(NeuCard)`
  flex: 1;
  overflow-y: scroll;
  overflow-x: hidden;
  scroll-behavior: smooth;
`;

export const InputHeading = styled.div<ICSSProps>`
  display: inline-block;
  font-size: 0.9375rem;
  line-height: 22px;
  margin-top: 0.75rem;
  margin-bottom: 0.4rem;
  ${({ autoWidth }) =>
    autoWidth &&
    css`
      width: auto;
    `}
`;

export const ModalTextArea = styled(NeuTextarea)`
  min-height: 88px;
  margin-bottom: 0.5rem;
`;

export const ModalFooter = styled(NeuCard)<IModalFooterProps>`
  background: white !important;
  bottom: 0;
  height: 69px !important;
  padding-top: var(--card-spacing) !important;
  ${props =>
    !props.right &&
    css`
      display: flex !important;
      justify-content: space-between !important;
    `}
`;

export const StyledEditHeaderRow = styled.div<ICSSProps>`
  display: flex;
  flex-direction: row;
  align-items: ${({ centered }) => (centered ? 'center' : 'start')};
`;

export const StyledEditHeaderCol = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledBoldHeading = styled(InputHeading)<ICSSProps>`
  font-weight: bold;
  ${({ autoWidth }) =>
    autoWidth &&
    css`
      width: auto;
    `}
  ${({ cursorType }) =>
    cursorType &&
    css`
      cursor: pointer;
    `}
    color: ${props => props.color} !important;
`;

export const StyledBoldHeadingCompleted = styled(InputHeading)<ICSSProps>`
  font-weight: bold;
  ${({ autoWidth }) =>
    autoWidth &&
    css`
      width: auto;
    `}
  ${({ cursorType }) =>
    cursorType &&
    css`
      cursor: pointer;
    `}
  color: ${props => props.color} !important;
  min-width: 180px;
`;

export const StyledRightAlignButton = styled(NeuButton)`
  align-self: end;
`;

export const StyledCircleDoneIcon = styled(NeuIcon)`
  background-color: #548a2c;
  border-radius: 50%;
`;

export const StyledDivider = styled.hr`
  width: 98%;
  margin-right: 1.5rem;
`;

export const StoplightCategory = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  min-height: 12px;
  color: #373737;
`;

export const BtnSpinner = styled(NeuFeedback)`
  margin: 0 1.57rem;
  > svg {
    height: 20px !important;
    width: 20px !important;
  }
`;

export const ItemContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const BlueText = styled.div`
  color: #206da3;
  font-size: 14px;
  line-height: 22px;
  font-weight: 700;
`;

export const SearchIcons = styled(NeuIcon)`
  display: flex;
  align-items: center;
  text-align: center;
  margin-right: 8px;
`;
export const TitleSpan = styled.span`
  display: flex;
  align-items: center;
  font-size: 16px;
  line-height: 26px;
  color: #06173d;
  width: 280px;
`;
export const TitleIcon = styled(NeuIcon)`
  margin-right: 8px;
  color: #5d99c8;
`;

/* View modal styles */
export const ViewIssueCard = styled(AddIssueCard)``;

export const TitleSpanView = styled.span`
  display: flex;
  font-size: 16px;
  line-height: 26px;
  color: #06173d;
  width: 280px;
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
export const IssueViewDiv = styled.div`
  margin-top: 15px;
`;
export const IssueViewSubDiv = styled.div`
  width: 50%;
`;
export const IssueViewDiv2Column = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 15px;
`;
export const LabelHeading = styled.div`
  width: 100%;
  margin-top: 15px;
  font-size: 0.9375rem;
  line-height: 22px;
`;

export const FooterDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex: 1;
`;

export const LabelContentPatient = styled.div<ICSSProps>`
  width: 100%;
  margin-top: 5px;
  font-weight: 700;
  font-size: 16px;
  line-height: 26px;
  ${({ cursorType }) =>
    cursorType &&
    css`
      cursor: pointer;
    `}
  color: ${props => props.color};
`;
export const LabelContentBold = styled.div`
  width: 100%;
  margin-top: 5px;
  font-weight: 700;
  font-size: 16px;
  line-height: 26px;
  color: #191919;
`;

export const FooterText = styled.div`
  font-style: italic;
  font-weight: 400;
  font-size: 15px;
  line-height: 26px;
  color: #000000;
  white-space: pre-wrap;
`;
export const TicketNumber = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;
  color: var(--primary-60);
  border-bottom: 2px solid var(--primary-60);
  cursor: pointer;
`;

export const ServiceCentralSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ViewStoplightsClickableLabel = styled.span`
  display: block;
  font-style: normal;
  font-weight: 700;
  font-size: 0.875rem;
  line-height: 22px;
  color: var(--primary-60);
  cursor: pointer;
`;

export const UnknownControlContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 97%;
  margin-bottom: 0.5rem;
`;
